import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomBadge from '@s-ui/react-atom-badge'

import {BADGE_TYPE_PROPS, TYPES} from './config.js'

const BASE_CLASS_NAME = 'mt-Panel-StepInfo'
const BADGE_ICON_CLASS_NAME = `${BASE_CLASS_NAME}BadgeIcon`

const PanelStepInfo = ({
  badgeIcon: BadgeIcon,
  badgeLabel,
  children,
  description,
  isDisabled = false,
  isFloating = false,
  title,
  type = TYPES.DEFAULT
}) => {
  const panelClassName = cx(BASE_CLASS_NAME, {
    [`${BASE_CLASS_NAME}--disabled`]: isDisabled,
    [`${BASE_CLASS_NAME}--floating`]: isFloating,
    [`${BASE_CLASS_NAME}--error`]: type === TYPES.ERROR,
    [`${BASE_CLASS_NAME}--success`]: type === TYPES.SUCCESS
  })

  const badgeIconClassName = cx(BADGE_ICON_CLASS_NAME, {
    [`${BADGE_ICON_CLASS_NAME}--noLabel`]: !badgeLabel
  })

  const badgeProps = BADGE_TYPE_PROPS[type] || BADGE_TYPE_PROPS[TYPES.DEFAULT]

  return (
    <div className={panelClassName}>
      <h3 className={`${BASE_CLASS_NAME}Title`}>{title}</h3>
      {Boolean(description) && <p className={`${BASE_CLASS_NAME}Description`}>{description}</p>}
      {children}
      {(Boolean(badgeLabel) || Boolean(BadgeIcon)) && (
        <div className={`${BASE_CLASS_NAME}Badge`}>
          <AtomBadge
            {...badgeProps}
            {...(BadgeIcon && {
              icon: (
                <span className={badgeIconClassName}>
                  <BadgeIcon />
                </span>
              )
            })}
            label={badgeLabel || ''}
          />
        </div>
      )}
    </div>
  )
}

PanelStepInfo.propTypes = {
  children: PropTypes.node,
  description: PropTypes.string,
  isDisabled: PropTypes.bool,
  isFloating: PropTypes.bool,
  badgeIcon: PropTypes.node,
  badgeLabel: PropTypes.string,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(TYPES))
}

export default PanelStepInfo

export {TYPES as panelStepInfoTypes}
